import type { RouterConfig } from '@nuxt/schema';

export default <RouterConfig>{
  scrollBehavior(
    _to,
    _from,
    savedPosition: { left: number; top: number } | null,
  ) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
};
